/* eslint-disable  */
import React, { useEffect, useState } from "react";
import RenderAdminPage from "../RenderAdminPage";
import { useDispatch, useSelector } from "react-redux";
import {
  GetLoanAllReport,
  GetLoanReport,
  GetMartReport,
} from "../../services/Actions/dataAction";
import { RolesContants } from "../../contants";
import { GetUserProfile } from "../../services/Actions/authActions";
import { ToastContainer, toast } from "react-toastify";
import { bindActionCreators } from "redux";
import { dataActionCreators } from "../../services/Actions";
import { COHORT } from "../../Components/CohortFilter";
import ReportWorkspace from "../../Components/ReportWorkspace";

function AdminReport() {
  const dispatch = useDispatch();
  const { ResetDataResponse } = bindActionCreators(
    dataActionCreators,
    dispatch
  );

  // "loans" | "mart"
  const [reportType, setReportType] = useState("loans");
  const [formData, setFormData] = useState({
    category: "",
    fromDate: "",
    toDate: "",
  });
  // Which button triggered the current download: "range" | "all" | null
  const [activeAction, setActiveAction] = useState(null);
  // Members and UPNMG staff are reported separately for both loans and mart —
  // generate one, then switch and generate the other.
  const [cohort, setCohort] = useState(COHORT.MEMBERS);
  const memberType = cohort === COHORT.STAFF ? "STAFF" : undefined;

  const data = useSelector((state) => state?.data);
  const user = useSelector((state) => state?.auth);
  const { isLoading, response } = data;

  const isMart = reportType === "mart";
  const entity = isMart ? "order" : "loan";

  useEffect(() => {
    dispatch(GetUserProfile());
  }, [dispatch]);

  // Clear the active button once the download finishes
  useEffect(() => {
    if (!isLoading) setActiveAction(null);
  }, [isLoading]);

  const handleSwitchType = (type) => {
    if (type === reportType) return;
    setReportType(type);
    // Status options differ between loans and mart, so reset the selection.
    setFormData((prev) => ({ ...prev, category: "" }));
  };

  const isAuthorized = () => user?.role?.includes(RolesContants.ADMIN);

  const handleGenerate = () => {
    if (!isAuthorized()) {
      toast.error(`You are not authorized to generate ${entity} reports`);
      return;
    }
    if (!formData.category) {
      toast.error("Select a status to generate the report");
      return;
    }
    if (!formData.fromDate || !formData.toDate) {
      toast.error("Choose the date range. This is required");
      return;
    }
    if (formData.fromDate > formData.toDate) {
      toast.error("The end date must be on or after the start date");
      return;
    }
    setActiveAction("range");
    if (isMart) {
      dispatch(
        GetMartReport(
          formData.category,
          formData.fromDate,
          formData.toDate,
          memberType
        )
      );
    } else {
      dispatch(
        GetLoanReport({
          ...formData,
          is_all: false,
          isOneDomain: false,
          member_type: memberType,
        })
      );
    }
  };

  const handleGenerateAll = () => {
    if (!isAuthorized()) {
      toast.error(`You are not authorized to generate ${entity} reports`);
      return;
    }
    // Mart "all" is still scoped to a date range; loans "all" exports everything.
    if (isMart && (!formData.fromDate || !formData.toDate)) {
      toast.error("Choose the date range. This is required");
      return;
    }
    if (isMart && formData.fromDate > formData.toDate) {
      toast.error("The end date must be on or after the start date");
      return;
    }
    setActiveAction("all");
    if (isMart) {
      dispatch(
        GetMartReport("all", formData.fromDate, formData.toDate, memberType)
      );
    } else {
      dispatch(GetLoanAllReport(memberType));
    }
  };

  useEffect(() => {
    if (response?.state === "SUCCESS") {
      toast.success(response?.message);
      setTimeout(() => {
        ResetDataResponse();
      }, 1500);
    } else if (response?.state === "ERROR") {
      toast.error(response?.message);
      setTimeout(() => {
        ResetDataResponse();
      }, 1500);
    }
  }, [response?.state, ResetDataResponse]);

  return (
    <RenderAdminPage title="Reports">
      <ReportWorkspace
        title="Reports"
        reportType={reportType}
        onReportTypeChange={handleSwitchType}
        formData={formData}
        setFormData={setFormData}
        cohort={cohort}
        onCohortChange={setCohort}
        isLoading={isLoading}
        activeAction={activeAction}
        onGenerate={handleGenerate}
        onGenerateAll={handleGenerateAll}
      />
      <ToastContainer autoClose={3000} />
    </RenderAdminPage>
  );
}

export default AdminReport;
